import ConfirmDialog from '01_core/components/system/ConfirmDialog';
import InfoBar from '01_core/components/system/InfoBar';
import { createThemeOption } from '01_core/components/system/theme';
import envUtil, { ENV_KEY } from '01_core/logics/envUtil';
import { sendErrorLog } from '01_core/logics/sendLog';
import { TYPES_CORE_CONDITION, coreConditionActions } from '01_core/reducers/coreConditionActions';
import { TYPES_CONFIRM, coreConfirmActions } from '01_core/reducers/coreConfirmActions';
import { TYPES_INFO_BAR, coreInfoBarActions } from '01_core/reducers/coreInfoBarActions';
import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import LoginContainer from '../login/LoginContainer';
import BaseContainer from './BaseContainer';

export class App extends Component {
  joinLocaleData = (language, labelData, codeData, contactUs, privacyPolicy, menuLabel) => {
    const intlData = { ...(labelData?.[language] || {}) };

    Object.keys(codeData || {}).forEach((codeType) => {
      (codeData[codeType] || []).forEach((code) => {
        const v = code?.[language];
        if (v != null) intlData[code.key] = v;
      });
    });

    if (contactUs?.[language] != null) intlData['contact_us'] = contactUs[language];
    if (privacyPolicy?.[language] != null) intlData['privacy_policy'] = privacyPolicy[language];

    Object.keys(menuLabel || {}).forEach((fid) => {
      const v = menuLabel[fid]?.[language];
      if (v != null) {
        intlData['menu.' + fid] = v;
      } else {
        // console.warn('menuLabel不足:', fid, language);
      }
    });

    return intlData;
  };

  chooseLocale = (language) => {
    const { locale } = this.props;

    const normalize = (lng) => {
      const lower = (lng || 'en').toLowerCase();
      if (lower.startsWith('ja')) return 'ja';
      if (lower.startsWith('en')) return 'en';
      return 'en';
    };
    const lang = normalize(language);

    // 最低限のフォールバック（初期表示で欠けないように）
    const baseMinimum = {
      'label.core.cancel': 'Cancel',
      'label.core.ok': 'OK',
    };

    const baseEn =
      this.joinLocaleData('en', locale.label, locale.code, locale.contactUs, locale.privacyPolicy, locale.menuLabel) ||
      {};
    const target =
      this.joinLocaleData(lang, locale.label, locale.code, locale.contactUs, locale.privacyPolicy, locale.menuLabel) ||
      {};

    return { ...baseMinimum, ...baseEn, ...target };
  };

  urlParamToObject = (urlParam) => {
    if (!urlParam) {
      return undefined;
    }
    let params = {};
    urlParam
      .substring(1)
      .split('&')
      .forEach((param) => {
        const tmp = param.split('=');
        params = {
          ...params,
          [tmp[0]]: tmp[1],
        };
      });
    return params;
  };

  componentDidMount = () => {
    const { loginInfo, closeInfoBar, closeConfirm, setDirty } = this.props;

    window.onerror = (message, file, lineNo, colNo, error) => {
      sendErrorLog(loginInfo.sessionId, 'Window onerror', error);
    };

    window.onunhandledrejection = (event) => {
      event.preventDefault();
    };

    window.onpopstate = (event) => {
      closeInfoBar();
      closeConfirm();
      setDirty(false);
    };
  };

  component = () => {
    if (!this.props.loginInfo.sessionId) {
      return <LoginContainer />;
    } else {
      const params = this.urlParamToObject(window.location.search);
      let mode = null;
      if (params) {
        mode = params.mode;
      }
      return <BaseContainer replaceReducer={this.props.replaceReducer} mode={mode} />;
    }
  };

  render = () => {
    const { locale, infoBar, confirm, closeInfoBar, closeConfirm, font } = this.props;
    let _theme = createTheme(createThemeOption(font.fontsize));
    const contextRoot = envUtil.getEnv(ENV_KEY.CONTEXT_ROOT);

    const messages = this.chooseLocale(locale.language);

    return (
      <IntlProvider
        locale={locale.language}
        key={locale.language}
        messages={messages}
        onError={(e) => {
          if (e.code === 'MISSING_TRANSLATION') return;
          // eslint-disable-next-line no-console
          console.error(e);
        }}
      >
        <BrowserRouter basename={contextRoot}>
          <ThemeProvider theme={_theme}>
            {this.component()}
            <InfoBar open={infoBar.isOpen} onClose={closeInfoBar} variant={infoBar.type} message={infoBar.message} />
            <ConfirmDialog
              open={confirm.isOpen}
              title={confirm.title}
              message={confirm.message}
              handleClose={closeConfirm}
              handleOk={confirm.onClickOk}
            />
          </ThemeProvider>
        </BrowserRouter>
      </IntlProvider>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    confirm: state.coreConfirm,
    infoBar: state.coreInfoBar,
    locale: state.coreLocale,
    font: state.coreFont,
    loginInfo: state.coreLoginInfo,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setDirty: (dirty) => dispatch(coreConditionActions[TYPES_CORE_CONDITION.SET_DIRTY](dirty)),
    closeInfoBar: () => dispatch(coreInfoBarActions[TYPES_INFO_BAR.CLOSE]()),
    closeConfirm: () => dispatch(coreConfirmActions[TYPES_CONFIRM.CLOSE]()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);